import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ''}/api`,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('arman_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('arman_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const projectsApi = {
  getAll: (params) => api.get('/projects', { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/admin/projects', data),
  update: (id, data) => api.put(`/admin/projects/${id}`, data),
  remove: (id) => api.delete(`/admin/projects/${id}`),
};

export const testimonialsApi = {
  getAll: () => api.get('/testimonials'),
  create: (data) => api.post('/admin/testimonials', data),
  update: (id, data) => api.put(`/admin/testimonials/${id}`, data),
  remove: (id) => api.delete(`/admin/testimonials/${id}`),
};

export const blogApi = {
  getAll: (params) => api.get('/blog', { params }),
  getBySlug: (slug) => api.get(`/blog/${slug}`),
  getAllAdmin: () => api.get('/admin/blog'),
  create: (data) => api.post('/admin/blog', data),
  update: (id, data) => api.put(`/admin/blog/${id}`, data),
  remove: (id) => api.delete(`/admin/blog/${id}`),
};

export const contactApi = {
  submit: (data) => api.post('/contact', data),
  getAll: () => api.get('/admin/contacts'),
  markRead: (id) => api.put(`/admin/contacts/${id}/read`),
  remove: (id) => api.delete(`/admin/contacts/${id}`),
};

export const settingsApi = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/admin/settings', data),
};

export const processStepsApi = {
  getAll: () => api.get('/process-steps'),
  update: (id, data) => api.put(`/admin/process-steps/${id}`, data),
};

export const statsApi = {
  get: () => api.get('/admin/stats'),
};

export const uploadApi = {
  image: (file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/admin/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const ordersApi = {
  create: (data) => api.post('/orders', data),
  getById: (id) => api.get(`/orders/${id}`),
  updateStep: (id, step, data) => api.put(`/orders/${id}/step/${step}`, data),
  uploadPlan: (id, file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post(`/orders/${id}/upload-plan`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  lookupByPhone: (orderNumber, phone) =>
    api.get('/orders/lookup/by-phone', { params: { order_number: orderNumber, phone } }),
  lookupByPassword: (orderNumber, password) =>
    api.get('/orders/lookup/by-password', { params: { order_number: orderNumber, password } }),
  // Admin
  getAll: (params) => api.get('/admin/orders', { params }),
  getByIdAdmin: (id) => api.get(`/admin/orders/${id}`),
  updateAdmin: (id, data) => api.put(`/admin/orders/${id}`, data),
  deleteAdmin: (id) => api.delete(`/admin/orders/${id}`),
  getNotifications: (id) => api.get(`/admin/orders/${id}/notifications`),
  getOrderStats: () => api.get('/admin/order-stats'),
};

export default api;
